import { StandardGridColumnId } from 'view/components/datagrid'
import { TradeSplitColumnId } from 'view/routes/tradeSplit/TradeSplitGrid/TradeSplitGridModel'
import {
  ResponderSalesCoverageColumnDefs,
  responderSalesCoverageGridOptions
} from 'view/routes/responderSalesCoverage/ResponderSalesCoverageGrid/ResponderSalesCoverageGridModel'

export const SalesCoveragePanelColumnDefs = ResponderSalesCoverageColumnDefs.filter(
  colDef =>
    colDef.colId !== StandardGridColumnId.CHECKBOX &&
    colDef.colId !== StandardGridColumnId.ACTIONS &&
    colDef.colId !== TradeSplitColumnId.MY_FIRM
)

export const salesCoveragePanelGridOptions = responderSalesCoverageGridOptions
